import {Component, OnInit} from '@angular/core';
import {GlobalsService} from '@/_services/globals.service';
import {BackendService} from '@/_services/backend.service';
import {MessageService} from '@/_services/message.service';
import {CloseButtonData} from '@/controls/close-button/close-button-data';
import {EnvironmentService} from '@/_services/environment.service';
import {PageDef, PageService} from '@/_services/page.service';
import {Utils} from '@/classes/utils';
import {CdkDrag, CdkDragHandle} from '@angular/cdk/drag-drop';
import {MatIcon} from '@angular/material/icon';
import {MatDialogActions, MatDialogContent, MatDialogTitle} from '@angular/material/dialog';
import {ReactiveFormsModule} from '@angular/forms';
import {MatFormField, MatInput, MatLabel, MatSuffix} from '@angular/material/input';
import {MatButton, MatIconButton} from '@angular/material/button';
import {CloseButtonComponent} from '@/controls/close-button/close-button.component';

@Component({
  selector: 'app-password-change',
  templateUrl: './password-change.component.html',
  styleUrl: './password-change.component.scss',
  imports: [
    CdkDrag,
    CdkDragHandle,
    MatIcon,
    MatDialogContent,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatDialogActions,
    MatIconButton,
    MatSuffix,
    MatButton,
    CloseButtonComponent,
    MatDialogTitle,
    MatInput
  ]
})
export class PasswordChangeComponent implements OnInit {
  hide = true;
  controls: any = {
    pwdOld: {label: $localize`Old Password`},
    pwdNew: {label: $localize`New Password`},
    pwdRep: {label: $localize`Repeat Password`},
  };
  closeData: CloseButtonData = {
    colorKey: 'password',
    showClose: true
  };
  page: PageDef;

  constructor(public globals: GlobalsService,
              public bs: BackendService,
              public env: EnvironmentService,
              public ps: PageService,
              public msg: MessageService) {
  }

  ngOnInit() {
    this.page = this.ps.initForm('password', this.controls);
  }

  clickSave() {
    this.ps.writeData('password');
    console.log(this.page.data);
    let msg: string;
    if (Utils.isEmpty(this.page.data.pwdOld)
      || Utils.isEmpty(this.page.data.pwdNew)
      || Utils.isEmpty(this.page.data.pwdRep)) {
      msg = $localize`You have to enter something in every field`;
    } else if (this.page.data.pwdNew !== this.page.data.pwdRep) {
      msg = $localize`The password repetition does not match`;
    }
    if (msg != null) {
      this.msg.error(msg);
      return;
    }
    this.bs.changePassword(this.page.data.pwdOld, this.page.data.pwdNew,
      () => {
        this.msg.info($localize`The password was changed successfully`);
        this.msg.closePopup();
      }, (error: string) => {
        this.msg.error(error);
      });
  }
}
